import Icon from "@mdi/react"
import { mdiCogOutline } from "@mdi/js"

import Button from "components/Buttons/Button"

import useTranslation from "hooks/useTranslation"

const ScrollToConfigurationsButton = () => {
	const { t } = useTranslation("product")

	return (
		<a href="#configuration" style={{ textDecoration: "none" }}>
			<Button
				style={{
					maxWidth: "230px",
				}}
			>
				<Icon
					path={mdiCogOutline}
					size={0.7}
					style={{ marginRight: "4px" }}
					color="#274041"
				/>
				{t("additionalConfigurations")}
			</Button>
		</a>
	)
}

export default ScrollToConfigurationsButton
